export default __webpack_public_path__ + "static/media/Learn-about-Pre-Markets-and-How-do-they-Work.634ef076.jpg";